import {
  NOT_ALLOWED_WIRE_STATUSES_CANCEL_OUTBOUND,
  NOT_ALLOWED_WIRE_STATUSES_EXECUTE,
} from '@/bundle/_OrgAdmin/shared/const/const';
import { Button } from '@/components/Button/Button';
import { RoundedButton } from '@/components/RoundedButton/RoundedButton';
import {
  isCancelledWireStatus,
  isExecutorAssignedWireStatus,
  isExecutorInvitedWireStatus,
  isPaymentDetailsProvidedWireStatus,
} from '@/helpers/wireHelpers';
import { AssignedWireType } from '@/types/wireTypes';

type OutboundWireHeaderActionsType = {
  wire: AssignedWireType;
  isLoadingWire: boolean;
  viewPaymentDetails: boolean;
  isShowExecutorAssignForm: boolean;
  onOpenCancelWireDialog: () => void;
  onOpenExecuteWireDialog: () => void;
  onAssignExecutorRedirect: () => void;
  onOpenCreateReplacementWireForm: () => void;
};

const MAX_ALLOWED_EXECUTORS_COUNT = 2;

export const OutboundWireHeaderActions = ({
  wire,
  isLoadingWire,
  viewPaymentDetails,
  isShowExecutorAssignForm,
  onOpenCancelWireDialog,
  onOpenExecuteWireDialog,
  onAssignExecutorRedirect,
  onOpenCreateReplacementWireForm,
}: OutboundWireHeaderActionsType) => {
  const wireStatus = wire?.status;
  const isCancelledStatus = isCancelledWireStatus(wireStatus);
  const isPaymentDetailsProvided = isPaymentDetailsProvidedWireStatus(wireStatus);
  const isShowedPaymentDetails = wire?.view_payment_details_event_register && wire?.is_payment_details_exist;
  const isAssignedExecutorStatus = isExecutorAssignedWireStatus(wireStatus);
  const isInvitedExecutorStatus = isExecutorInvitedWireStatus(wireStatus);

  const canCreateWire =
    isCancelledStatus && isShowedPaymentDetails && !wire?.child_wire && !wire?.parent_wire && !isLoadingWire;
  const canCreateReplacementWire = isCancelledStatus && isShowedPaymentDetails && wire?.parent_wire && !isLoadingWire;
  const cannotCreateReplacementWire = isCancelledStatus && isShowedPaymentDetails && wire?.child_wire && !isLoadingWire;
  const viewAndProvidedPaymentDetails = wire?.view_payment_details_event_register && isPaymentDetailsProvided;
  const canAddExecutors = wire.assigned_executors.length < MAX_ALLOWED_EXECUTORS_COUNT;
  const isAssignedOrInvitedExecutorStatus = isAssignedExecutorStatus || isInvitedExecutorStatus;

  // TODO v21.0.0: recheck condition when BE will be ready (recheck if isLoadingWire needed for second)
  const canAssignExecutor =
    (viewAndProvidedPaymentDetails && !isShowExecutorAssignForm && !isLoadingWire) ||
    (canAddExecutors && isAssignedOrInvitedExecutorStatus && !isShowExecutorAssignForm);

  const canExecuteWire =
    !NOT_ALLOWED_WIRE_STATUSES_EXECUTE.includes(wireStatus) &&
    viewPaymentDetails &&
    !isShowExecutorAssignForm &&
    !isLoadingWire;
  const canCancelWire = !NOT_ALLOWED_WIRE_STATUSES_CANCEL_OUTBOUND.includes(wireStatus) && !isLoadingWire;

  return (
    <>
      {canCancelWire && (
        <Button width={160} variant='secondary' mobileStretch onClick={onOpenCancelWireDialog}>
          Cancel Wire
        </Button>
      )}
      {canExecuteWire && (
        <Button width={160} onClick={onOpenExecuteWireDialog} mobileStretch>
          Wire Executed
        </Button>
      )}
      {canCreateWire && (
        <Button width={160} variant='secondary' onClick={onOpenCreateReplacementWireForm} mobileStretch>
          Create Wire
        </Button>
      )}

      {(canCreateReplacementWire || cannotCreateReplacementWire) && (
        <Button width={160} variant='secondary' disabled mobileStretch>
          Create Wire
        </Button>
      )}

      {canAssignExecutor && <RoundedButton onClick={onAssignExecutorRedirect}>Assign Executor</RoundedButton>}
    </>
  );
};
